const initHeroSlider = () => {
  const slider = document.querySelector(".hero-slider")
  if (!slider) return

  const slides = [...slider.querySelectorAll(".hero-slider-item")]
  const prevBtn = slider.querySelector(".hero-btn.prev")
  const nextBtn = slider.querySelector(".hero-btn.next")
  const slideCount = slides.length
  const AUTO_SLIDE_DELAY = 10000
  let currentIndex = 0
  let autoSlideInterval = null

  // Accessibility roles
  slider.setAttribute("role", "region")
  slider.setAttribute("aria-label", "Hero slider")

  // Initialize slides: only first slide visible and focusable
  slides.forEach((slide, idx) => {
    slide.tabIndex = idx === 0 ? 0 : -1
    slide.setAttribute("aria-hidden", idx === 0 ? "false" : "true")
    slide.classList.toggle("active", idx === 0)
  })

  // Show slide at given index with wrap-around and accessibility update
  function showSlide(index) {
    index = (index + slideCount) % slideCount

    slides.forEach((slide, idx) => {
      const isActive = idx === index
      slide.classList.toggle("active", isActive)
      slide.setAttribute("aria-hidden", !isActive)
      slide.tabIndex = isActive ? 0 : -1
      if (isActive) slide.focus({ preventScroll: true })
    })

    currentIndex = index
  }

  // Debounce slide changes using requestAnimationFrame for performance
  let animationFrameId = null
  function debouncedShowSlide(index) {
    if (animationFrameId) cancelAnimationFrame(animationFrameId)
    animationFrameId = requestAnimationFrame(() => {
      showSlide(index)
    })
  }

  // Navigation button handlers with reset auto slide
  prevBtn?.addEventListener("click", () => {
    debouncedShowSlide(currentIndex - 1)
    resetAutoSlide()
  })

  nextBtn?.addEventListener("click", () => {
    debouncedShowSlide(currentIndex + 1)
    resetAutoSlide()
  })

  // Keyboard navigation for arrow keys when slide focused
  slider.addEventListener("keydown", event => {
    if (event.target !== slides[currentIndex]) return

    if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
      event.preventDefault()
      showSlide(currentIndex - 1)
      resetAutoSlide()
    }

    if (event.key === "ArrowRight" || event.key === "ArrowDown") {
      event.preventDefault()
      showSlide(currentIndex + 1)
      resetAutoSlide()
    }
  })

  // Touch swipe support with passive event listeners & threshold
  let touchStartX = 0
  let isSwiping = false
  const SWIPE_THRESHOLD = 40

  slider.addEventListener(
    "touchstart",
    e => {
      if (e.touches.length === 1) {
        touchStartX = e.touches[0].clientX
        isSwiping = true
      }
    },
    { passive: true }
  )

  slider.addEventListener(
    "touchend",
    e => {
      if (!isSwiping) return
      isSwiping = false
      const touchEndX = e.changedTouches[0].clientX
      const deltaX = touchEndX - touchStartX

      if (deltaX > SWIPE_THRESHOLD) {
        debouncedShowSlide(currentIndex - 1)
        resetAutoSlide()
      } else if (deltaX < -SWIPE_THRESHOLD) {
        debouncedShowSlide(currentIndex + 1)
        resetAutoSlide()
      }
    },
    { passive: true }
  )

  // Auto slide with reduced motion check and page visibility API support
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

  function startAutoSlide() {
    if (prefersReducedMotion || slideCount < 2 || autoSlideInterval !== null) return
    autoSlideInterval = setInterval(() => {
      showSlide(currentIndex + 1)
    }, AUTO_SLIDE_DELAY)
  }

  function stopAutoSlide() {
    clearInterval(autoSlideInterval)
    autoSlideInterval = null
  }

  function resetAutoSlide() {
    stopAutoSlide()
    startAutoSlide()
  }

  // Pause auto slide on mouse enter, focus, or page hidden to improve UX and performance
  slider.addEventListener("mouseenter", stopAutoSlide)
  slider.addEventListener("focusin", stopAutoSlide)
  slider.addEventListener("mouseleave", startAutoSlide)
  slider.addEventListener("focusout", startAutoSlide)

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      stopAutoSlide()
    } else {
      resetAutoSlide()
    }
  })

  startAutoSlide()
}

document.addEventListener("DOMContentLoaded", initHeroSlider)
